import { ContractInformation, getContractInformation } from 'api/v1/information'
import { atom } from 'jotai'
import { SymbolName } from 'types'

export const contractInformationSymbolAtom = atom<SymbolName>('')

export const contractInformationAtom = atom<
  Promise<Partial<ContractInformation>>
>(async (get) => {
  const currentSymbol = get(contractInformationSymbolAtom)
  if (!currentSymbol) return {}
  const { data } = await getContractInformation(currentSymbol).catch((e) => {
    console.error(e)
    return {
      data: {},
    }
  })
  return data
})
